interface IRuntimeForm {
  [key: string]: any;
}

export class RuntimeForm<T extends IRuntimeForm> {
  private readonly form: T;

  constructor(form: T) {
    this.form = form;
  }

  public formData(): FormData {
    const form = new FormData();

    // eslint-disable-next-line no-restricted-syntax
    for (const key in this.form) {
      if (this.form[key] !== undefined) {
        const field = this.form[key];

        if (Array.isArray(field)) {
          field.forEach((item: any) => {
            form.append(`${key}[]`, item);
          });
        } else {
          form.append(key, field);
        }
      }
    }

    return form;
  }
}
